import { Loading, useFetch } from "@4uhub/lib4uhub";
import { useMediaQuery, useTheme } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import NoData from "../../../components/UI/NoData";
import MyTriagesTable from "./MyTriagesTable/MyTriagesTable";
import TriageList from "./TriageList";
import {
  ITriageCheckInRule,
  ITriageEmergencyDepartments,
} from "../../../models/triage";
import TriageEmergencyDepartment from "../../../services/triageEmergencyDepartment.service";

interface ITriagesProps {
  lastHours?: boolean;
}
const Triages: React.FC<ITriagesProps> = ({ lastHours = false }) => {
  const [triages, setTriage] = useState<ITriageEmergencyDepartments[]>([]);

  const [checkInRule, setCheckInRule] = useState<ITriageCheckInRule | null>(
    null
  );

  const { t } = useTranslation();

  const { sendRequest, loading } = useFetch(
    TriageEmergencyDepartment.getTriages
  );

  const { breakpoints } = useTheme();

  const mobile = useMediaQuery(breakpoints.down("md"));

  const fetch = useCallback(async () => {
    const { data, success } = await sendRequest({
      Last24hoursData: lastHours,
    });

    if (data && success) {
      setTriage(data.triageEmergencyDepartments);
      setCheckInRule(data.tasyTriageCheckInRule);
    }
  }, [sendRequest, lastHours]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  if (loading) {
    return <Loading />;
  }

  if (triages && triages.length === 0) {
    return <NoData message={t("page.schedules.home.noFound")} />;
  }

  if (mobile) {
    return <TriageList data={triages} checkInRule={checkInRule!} />;
  }

  return <MyTriagesTable data={triages} checkInRule={checkInRule!} />;
};

export default memo(Triages);
